import { MARQUEE_ITEMS } from "@/data/content";

const Row = () => (
  <div className="flex shrink-0 items-center">
    {MARQUEE_ITEMS.map((item) => (
      <span key={item} className="flex items-center">
        <span className="whitespace-nowrap px-8 font-label text-sm tracking-[0.34em] text-[#9A7B24]/70">
          {item.toUpperCase()}
        </span>
        <span aria-hidden className="h-1.5 w-1.5 rotate-45 bg-[#D4AF37]/50" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div
    data-testid="editorial-marquee"
    className="overflow-hidden border-y border-[#D4AF37]/15 bg-[#FFFFFF]/40 py-6"
  >
    <div className="marquee-track flex w-max">
      <Row />
      <Row />
    </div>
  </div>
);
